const items = [
  "Goal-Based Planning",
  "Mutual Funds",
  "SIP Solutions",
  "Portfolio Reporting",
  "Tax-Saving Strategies",
  "Retirement Planning",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <section
      data-testid="marquee-section"
      aria-hidden="true"
      className="bg-wealth border-y border-brand/25 py-6 overflow-hidden"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-display text-2xl md:text-3xl font-medium italic text-bone/90 px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="text-brand-light text-lg">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
